import { useForm, useFormState } from "react-hook-form";

import { useFormAction } from ".";

export function useFormModal(formId, defaultValues, onDone) {
  const formProps = useForm({ mode: "onChange", defaultValues: defaultValues });
  const { isValid } = useFormState({ control: formProps.control });
  const { submit, isSubmitting } = useFormAction(formId, onDone);

  return {
    formProps: formProps,
    isReady: isValid,
    isSubmitting: isSubmitting,
    submit: submit,
  };
}

export default useFormModal;
